import { api } from '@/api/client'
import type { ChatMessage, ChatMessagesPage } from './types'

export async function fetchChatMessages(opts?: {
  beforeId?: number
  limit?: number
}): Promise<ChatMessagesPage> {
  const params = new URLSearchParams({ meta: '1' })
  if (opts?.beforeId) params.set('beforeId', String(opts.beforeId))
  if (opts?.limit) params.set('limit', String(opts.limit))
  const data = await api<ChatMessagesPage | ChatMessage[]>(`/api/chat/messages?${params}`)
  if (Array.isArray(data)) {
    return { messages: data, hasMore: data.length >= (opts?.limit || 50) }
  }
  return {
    messages: data.messages || [],
    hasMore: Boolean(data.hasMore),
  }
}

export async function uploadChatFiles(files: File[]): Promise<string[]> {
  if (!files.length) return []
  const form = new FormData()
  files.forEach((f) => form.append('files', f))
  const data = await api<{ files?: string[] }>('/api/chat/upload', {
    method: 'POST',
    body: form,
    skipJson: true,
  })
  return data.files || []
}
